(function ($) {
    $.fn.programBody = function () {
        return this.each(() => {

            //$('.main-left-content ~ *').wrapAll('<div class="program-right-block"></div>')
            //$('.program-detail ~ *').wrapAll('<div class="container main-content-wrapper"></div>')

        })
    }

})($);


export default {
    init() {
        // JavaScript to be fired on the workstream details
        $('.program-content-body').programBody();

    },
    finalize() {
        // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-program.js